export default __webpack_public_path__ + "static/media/round.6ff24bff.svg";